<template>
  <div :class="['dialog', { visible: visible }]">
    <div class="header">
      <div class="title">在售商品</div>
    </div>
    <div class="closeBtn" @click="close"></div>
    <div class="content">
      <a-tabs v-model="currentTab">
        <a-tab-pane :key="1" tab="大宗商品">
          <div class="list">
            <div v-for="item in listB" :key="item.id" class="list-item">
              <div class="cover">
                <img :src="item.url || require('@/img/agriculture/default_cover.png')" alt="" />
              </div>
              <div class="name two-line">{{ item.name }}</div>
            </div>
          </div>
          <a-pagination
            v-model="pageB.current"
            :page-size="pageB.size"
            :total="pageB.total"
            show-less-items
            @change="onChange"
          />
        </a-tab-pane>
        <a-tab-pane :key="2" tab="零售商品">
          <div class="list">
            <div v-for="item in listC" :key="item.id" class="list-item">
              <div class="cover">
                <img :src="item.url || require('@/img/agriculture/default_cover.png')" alt="" />
              </div>
              <div class="name two-line">{{ item.name }}</div>
            </div>
          </div>
          <a-pagination
            v-model="pageC.current"
            :page-size="pageC.size"
            :total="pageC.total"
            show-less-items
            @change="onChange"
          />
        </a-tab-pane>
        <a-tab-pane :key="3" tab="校园餐商品">
          <div class="list">
            <div v-for="item in listS" :key="item.id" class="list-item">
              <div class="cover">
                <img :src="item.imgName || require('@/img/agriculture/default_cover.png')" alt="" />
              </div>
              <div class="name two-line">{{ item.materialName }}</div>
            </div>
          </div>
          <a-pagination
            v-model="pageS.current"
            :page-size="pageS.size"
            :total="pageS.total"
            show-less-items
            @change="onChange"
          />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import { onsaleMaterailPage, groupMaterialPage } from '@/api/dashboard'
import to from '@/utils/await-to'
export default {
  name: 'ProductDialog',
  data() {
    return {
      visible: false,
      currentTab: 1,
      listB: [],
      listC: [],
      listS: [],
      pageB: {
        current: 1,
        size: 27,
        total: 0,
      },
      pageC: {
        current: 1,
        size: 27,
        total: 0,
      },
      pageS: {
        current: 1,
        size: 27,
        total: 0,
      },
    }
  },
  methods: {
    show() {
      this.visible = true
      this.initData(1)
      this.initData(2)
      this.initDataSchool()
    },
    close() {
      this.visible = false
    },
    async initData(apply) {
      let current
      let size
      if (apply == 1) {
        current = this.pageB.current
        size = this.pageB.size
      }
      if (apply == 2) {
        current = this.pageC.current
        size = this.pageC.size
      }
      const [res, err] = await to(onsaleMaterailPage({ current, size, apply }))
      if (err) return
      if (apply == 1) {
        this.listB = res.data.list
        this.pageB.total = res.data.total
      }
      if (apply == 2) {
        this.listC = res.data.list
        this.pageC.total = res.data.total
      }
    },
    async initDataSchool(apply) {
      const [res, err] = await to(
        groupMaterialPage({ current: this.pageS.current, size: this.pageS.size, apply }),
      )
      if (err) return
      this.listS = res.data.list
      this.pageS.total = res.data.total
    },
    onChange(current) {
      if (this.currentTab == 1) {
        this.pageB.current = current
        this.initData(1)
      }
      if (this.currentTab == 2) {
        this.pageC.current = current
        this.initData(2)
      }
      if (this.currentTab == 3) {
        this.pageS.current = current
        this.initDataSchool()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog {
  z-index: 99999999;
  width: 3136px !important;
  height: 1638px !important;
  background: url('~@/img/agriculture/product_bg.png');
  background-size: 100% 100%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: none;

  ::v-deep .ant-tabs {
    height: 100%;
    padding-top: 40px;
    .ant-tabs-bar {
      margin-bottom: 40px;
    }
    .ant-tabs-nav {
      .ant-tabs-tab {
        font-size: 40px;
        color: #e8e8e8;
        padding: 12px 20px;
        margin: 0 20px 0 0;

        &.ant-tabs-tab-active {
          color: #0095fe;
        }
      }

      .ant-tabs-ink-bar {
        background-color: #0095fe;
        height: 3px;
      }
    }
    .ant-tabs-nav {
      margin-bottom: 0;
    }
    .ant-tabs-content {
      height: calc(100% - 90px);
    }

    .ant-tabs-tabpane {
      height: 100%;
    }
  }

  .header {
    display: flex;
    align-items: center;
    padding: 30px 0 0 60px;

    .title {
      font-size: 48px;
      color: #ffffff;
      font-weight: 500;
    }
  }

  .closeBtn {
    cursor: pointer;
    width: 58px;
    height: 58px;
    position: absolute;
    right: 40px;
    top: 34px;
    background: url('~@/img/agriculture/close_btn.png');
    background-size: 100% 100%;
  }

  .content {
    padding: 20px 140px 0;
    height: calc(100% - 120px);

    .list {
      display: flex;
      flex-wrap: wrap;
      max-height: calc(100% - 120px);
      overflow-y: auto;

      .list-item {
        width: 280px;
        height: 340px;
        margin-right: 35px;
        margin-bottom: 30px;
        padding: 15px;
        box-sizing: border-box;
        background: rgba(0, 40, 40, 0.6);
        border: 2px solid #0041b8;
        border-radius: 4px;

        &:nth-of-type(9n) {
          margin-right: 0;
        }

        .cover {
          width: 100%;
          height: 240px;
          margin-bottom: 15px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .name {
          font-weight: normal;
          font-size: 22px;
          color: #ffffff;
          height: 50px;
          line-height: 25px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }

    ::v-deep .ant-pagination {
      position: absolute;
      bottom: 60px;
      left: 0;
      width: 100%;
      text-align: center;

      .ant-pagination-prev,
      .ant-pagination-next {
        width: auto;
        height: 50px;
        line-height: 50px;
        border: none;
        background: transparent;

        .ant-pagination-item-link {
          color: #fff;
          font-size: 24px;
          background: transparent;
          border: none;
        }

        &.ant-pagination-disabled {
          .ant-pagination-item-link {
            color: #666;
          }
        }
      }

      > li {
        width: 50px;
        height: 50px;
        box-sizing: border-box;
        border: 2px solid #0041b8;
        font-weight: normal;
        font-size: 24px;
        line-height: 46px;
        text-align: center;
        background-color: transparent;
        margin: 0 8px;

        a {
          color: #0041b8;
        }

        &.ant-pagination-item-active {
          background-color: #0041b8;

          a {
            color: #fff;
          }
        }
      }
    }
  }

  &.visible {
    display: block;
    animation: anim-open 0.5s ease;
  }

  @keyframes anim-open {
    0% {
      transform: translate(-50%, -50%) scale(0);
    }

    100% {
      transform: translate(-50%, -50%) scale(1);
    }
  }
}
</style>
